import { FileDetailCardActionProps } from '@/modules/FileDetail/components/action/myFileActions/FileDetailCardAction.types';
import EditVisitTimeAction from '@/modules/FileDetail/components/action/myFileActions/EditVisitTimeAction';

const FileDetailCardAction = ({
  action,
  onClick,
}: FileDetailCardActionProps) => {
  if (!action?.has_actions) {
    return <></>;
  }
  if (action?.actions === 'time_set' || action?.actions === 'edit_visit_time') {
    return <EditVisitTimeAction onClick={() => onClick?.()} />;
  }
};
export default FileDetailCardAction;
